import { render, staticRenderFns } from "./RgsToggle.vue?vue&type=template&id=813515de&scoped=true&"
import script from "./RgsToggle.vue?vue&type=script&lang=ts&"
export * from "./RgsToggle.vue?vue&type=script&lang=ts&"
import style0 from "./RgsToggle.vue?vue&type=style&index=0&id=813515de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813515de",
  null
  
)

export default component.exports